import { SUPPORTED_LANGUAGES } from "@planvera/app-commons/i18n";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "en",
		supportedLngs: [...SUPPORTED_LANGUAGES],
		// Translation folders use base languages, never regional tags: without
		// this a browser at `fi-FI` fetches `/locales/fi-FI/*.json` and 404s.
		load: "languageOnly",
		debug: import.meta.env.DEV,
		ns: ["common", "admin", "auth", "dashboard"],
		defaultNS: "common",
		interpolation: {
			escapeValue: false, // React already escapes values
		},
		react: {
			// Namespaces are lazy-loaded over HTTP, so the first switch to a
			// never-used language fires `languageChanged` before its JSON arrives;
			// the default `bindI18nStore: ""` never re-renders on the late load, so
			// the first switch appears to do nothing. Re-render on lazy bundle load.
			bindI18nStore: "added",
		},
		backend: {
			loadPath: "/locales/{{lng}}/{{ns}}.json",
		},
		detection: {
			order: ["localStorage", "navigator"],
			caches: ["localStorage"],
			lookupLocalStorage: "i18nextLng",
		},
	});

export default i18n;
